const styles = {
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '14px',
        lineHeight: '21px',
        textAlign: 'center',
        color: '#001533',
        paddingLeft: '16px',
        fontWeight: '600',
        textTransform: 'capitalize',
    },
    rowLabel: {
        fontFamily: 'Silka_Regular',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '400',
        color: '#4D5C71',
        paddingLeft: '10px',
    },
    email: {
        display: 'flex',
        alignItems: 'center',
    },
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '48px',
    },
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '598px',
        height: '48px',
        margin: '0px 24px',
    },
};
export default styles;
